import { getLabel } from '../../../validators'

export function getInputLabel(name: string, inputLabel: string | undefined) {
    return inputLabel || getLabel(name)
}
